import Logo from "../../img/logo_negative.png"
import '../NavBar/Navbar.css'
import React, { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Menu, X } from "lucide-react"

const NavBar = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50)
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const navLinks = [
        { name: "SOBRE NÓS", href: "#sobre" },
        { name: "SERVIÇOS", href: "#servicos" },
        { name: "ESTRUTURA", href: "#estrutura" },
        { name: "CONTATOS", href: "#mapa" },
    ]


    const scrollToSection = (e, href) => {
        e.preventDefault()
        const element = document.querySelector(href)
        if (element) {
            const offsetTop = element.offsetTop - 80
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            })
            setMenuOpen(false)
        }
    }

    return (
        <nav id='navbar' className={scrolled ? "scrolled" : ""}>
            <a href="#home" onClick={(e) => scrollToSection(e, "#home")} id='logo'>
                <img src={Logo} alt='Logo Stuttgart' className='logo' />
            </a>

            <div className='menu' onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? <X size={28} /> : <Menu size={28} />}
            </div>

            <ul className={menuOpen ? "open" : ""}>
                {navLinks.map((link, index) => (
                    <motion.li
                        key={link.name}
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <a
                            href={link.href}
                            onClick={(e) => scrollToSection(e, link.href)}
                        >
                            {link.name}
                        </a>
                    </motion.li>
                ))}
            </ul>
        </nav>
    )
}

export default NavBar;
